import type { Property } from 'csstype';

export interface Position<T = string | number> {
	x: Property.Left<T>;
	y: Property.Top<T>;
}

/*
const POSITIONS: Position[] = [
	{ x: "35vw", y: "58vh" },
	{ x: "53vw", y: "26vh" },
	{ x: "57vw", y: "72vh" },
	{ x: "24vw", y: "18vh" },
	{ x: "67vw", y: "44vh" },
	{ x: "8vw", y: "26vh" },
	{ x: "44vw", y: "44vh" },
	{ x: "37vw", y: "18vh" },
	{ x: "38vw", y: "79vh" }
];
*/
const POSITIONS: Position[] = [
	{ x: '65%', y: '48%' },
	{ x: '53%', y: '26%' },
	{ x: '58%', y: '78%' },
	{ x: '35%', y: '59%' },
	{ x: '24%', y: '18%' },
	{ x: '8%', y: '26%' },
	{ x: '44%', y: '44%' },
	{ x: '37%', y: '18%' },
	{ x: '38%', y: '79%' }
];

export const getMapPosition = (personaIndex: number): Position => {
	if (!POSITIONS[personaIndex]) {
		throw new Error('No position for persona index ' + personaIndex);
	}
	return POSITIONS[personaIndex];
};
